<template>
  <div class="container_request">
    <ProcessedRequestEmail
      v-if="isDisplay(requestStatusKey.PROCESSED)"
      ref="processed-request"
      class="request__processed"
      :email="email"
    />
    <ExpiredRequestEmail
      v-if="isDisplay(requestStatusKey.EXPIRED)"
      ref="expired-request"
      class="request__expired"
    />
    <FailedRequestEmail
      v-if="isDisplay(requestStatusKey.FAILED)"
      ref="failed-request"
      class="request__failed"
    />
  </div>
</template>

<script>
import ProcessedRequestEmail from './Components/ProcessedRequestEmail.vue';
import ExpiredRequestEmail from './Components/ExpiredRequestEmail.vue';
import FailedRequestEmail from './Components/FailedRequestEmail.vue';

import jwt from 'jsonwebtoken';
import ChangeRequest from '@/models/ChangeRequest';
import Auth from '@/models/Auth';

const requestStatusInitKey = {
  PROCESSED: 'Processed',
  PENDING: 'Pending',
  EXPIRED: 'Expired',
  FAILED: 'Failed'
};
export default {
  components: {
    ProcessedRequestEmail,
    ExpiredRequestEmail,
    FailedRequestEmail
  },
  data() {
    return {
      requestStatusKey: requestStatusInitKey,
      requestStatus: '',
      email: '',
      requestId: ''
    };
  },

  created() {
    this.init();
  },
  methods: {
    //process
    async init() {
      let token = this.$route.query.token;
      if (!token) {
        this.$set(this, 'requestStatus', requestStatusInitKey.FAILED);
        return;
      }
      this.getRequestId(token);
      const { status } = await this.getChangeRequestPublicData();
      if (status === requestStatusInitKey.PENDING) {
        this.verifyRequestChange();
      }

      this.$set(this, 'requestStatus', status);
    },
    async callVerifyRequestChange() {
      return await ChangeRequest.api().verifyRequestChange({ token: this.$route.query.token });
    },
    async verifyRequestChange() {
      //call api to verify
      try {
        const {
          response: { data }
        } = await this.callVerifyRequestChange();

        if (data.data.status === requestStatusInitKey.PROCESSED) {
          await this.revokeToken();
          
          // Silent logout - clear session without redirect
          Auth.signOut(false);
        }
        this.$set(this, 'requestStatus', data.data.status);
      } catch (error) {
        if (error?.response?.data?.message?.message === 'Invalid token') {
          this.$set(this, 'requestStatus', requestStatusInitKey.EXPIRED);
        } else {
          this.$set(this, 'requestStatus', requestStatusInitKey.FAILED);
        }
      }
    },

    isDisplay(status) {
      //=============== check status ============
      return this.requestStatus === status;
    },

    async revokeToken() {
      //=============== call api revoke token ================
      const freshToken = Auth.getRefreshToken();

      if (!freshToken) {
        return;
      }

      return await Auth.api()
        .revokeToken(freshToken)
        .catch(() => {
          console.log('revoke token failed');
          this.$set(this, 'requestStatus', requestStatusInitKey.FAILED);
        });
    },

    async getChangeRequestPublicData() {
      const {
        response: { data }
      } = await ChangeRequest.api().getChangeRequestPublicData(this.requestId);
      if (data && data.request_data) {
        const request = data;
        const email = data.request_data.newEmail;
        this.$set(this, 'email', email);
        return { status: request.status };
      } else {
        return { status: requestStatusInitKey.FAILED };
      }
    },
    getRequestId(token) {
      const { payload } = jwt.decode(token, { complete: true });
      if (payload) {
        const currentTime = Math.floor(Date.now() / 1000);
        if (payload.exp && currentTime > payload.exp) {
          this.$set(this, 'requestStatus', requestStatusInitKey.EXPIRED);
          return;
        }
        const requestId = payload.requestChangeId;
        this.$set(this, 'requestId', requestId);
      } else {
        alert('Invalid token');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container_request {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 30%);
}
</style>
